import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import ActionButton from '@/components/action_button/Index.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import RadioBoxGroup from '@/views/v3/RadioBoxGroup.vue';
import MessengerMessages from '@/components/v3/inbox_manager/MessengerMessages.vue';
import PromptManagerDummyRecipient from '@/plugins/graphql/queries/v2/app-dummy-recipient.gql';
import AppEditablePrompts from '@/plugins/graphql/queries/v2/editable-prompts.gql';
import AppDefaultPrompts from '@/plugins/graphql/queries/v2/default-prompts.gql';
import BaseTextArea from '@/components/v2/BaseTextArea';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import SendMessengerDummyReply from '@/plugins/graphql/mutations/prompt_manager/create-dummy-inbox-message.gql';
import UpdateEditablePrompt from '@/plugins/graphql/mutations/prompt_manager/update-editable-prompt.gql';
import ResetPrompts from '@/plugins/graphql/mutations/prompt_manager/reset-prompts.gql';
import CreateNewDummyRecipient from '@/plugins/graphql/mutations/prompt_manager/create-new-dummy-recipient.gql';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import { ORANGE } from '@/helpers/constants/Switch';
let ComponentName = class ComponentName extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, WindowSizeListener, FormValidationsMixin, Mixins(FormMixin, AlertMixin, OrangeThemeMixin)) {
    constructor() {
        super(...arguments);
        this.duumyRecipient = null;
        this.form = {
            base: null,
            promoCode: null,
            faq: null,
            orderStatus: null,
        };
        this.prompts = [
            {
                title: 'Conversation Agent',
                editablePrompts: [
                    { title: 'Base Prompt', content: 'Base Prompt Content' },
                    { title: 'Promo Code', content: 'Promo Code Content' },
                    { title: 'Order Status', content: 'Order Status Content' },
                    { title: 'Q&A', content: 'Q&A Content' },
                ]
            },
        ];
        this.defaultPrompts = [
            {
                agentType: 'conversation_agent',
                agentPrompts: [
                    { name: 'base', content: '' },
                    { name: 'promoCode', content: '' },
                    { name: 'orderStatus', content: '' },
                    { name: 'faq', content: '' },
                ],
            },
        ];
        this.editablePrompts = [];
        this.typedMessage = '';
        this.sendingMessages = [];
        this.mobileCurrentTab = 'prompts';
        this.saving = false;
    }
    get switchColor() {
        return ORANGE;
    }
    toggleConfirmation() {
        this.showConfirmationDialog();
    }
    get showMessages() {
        if (this.xsOnly) {
            if (this.mobileCurrentTab === 'messages') {
                return true;
            }
            return false;
        }
        return true;
    }
    get showPrompts() {
        if (this.xsOnly) {
            if (this.mobileCurrentTab === 'prompts') {
                return true;
            }
            return false;
        }
        return true;
    }
    clearMsg() {
        this.typedMessage = '';
    }
    get disableSendButton() {
        const trimmedMessage = this.typedMessage.trim();
        return trimmedMessage === '';
    }
    receiveString(newString) {
        this.sendingMessages.push(newString);
    }
    deleteString() {
        this.sendingMessages.shift();
    }
    passMessage(string) {
        const vm = this;
        vm.$refs.messenger.receiveString(string);
    }
    async sendMessage() {
        const mutation = () => {
            return this.sendMessengerReply();
        };
        this.$nextTick(() => {
            this.passMessage(this.typedMessage.trim());
            this.clearMsg();
        });
        await mutation()
            .then(() => {
            this.successNotification('Message sent successfully');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    formatLabel(str) {
        if (str === 'faq') {
            return 'Q&A (FAQs)';
        }
        return str
            .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
            .replace(/^./, (s) => s.toUpperCase()); // Capitalize the first letter
    }
    formatTitle(str) {
        return str
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
    }
    async sendMessengerReply() {
        return this.$apollo
            .mutate({
            mutation: SendMessengerDummyReply,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    pageRecipientUuid: this.selectedRecipient.uuid,
                    platformOrigin: 'messenger',
                    message: this.typedMessage,
                },
            },
        })
            .catch((e) => {
            const vm = this;
            vm.$refs.messenger.deleteString();
        });
    }
    savePrompts() {
        const vm = this;
        vm.$v.$touch();
        if (!vm.$v.$invalid) {
            vm.saving = true;
            const variables = {
                input: {
                    appUuid: vm.appUUID,
                    agentType: ['conversation_agent'],
                    promoCodePrompt: this.form.promoCode,
                    faqPrompt: this.form.faq,
                    orderStatusPrompt: this.form.orderStatus,
                    generalAgentPrompt: this.form.base,
                },
            };
            return vm.$apollo
                .mutate({
                mutation: UpdateEditablePrompt,
                variables,
            })
                .then(() => {
                this.successNotification(`Successfully Saved Chatbot Prompts`);
                vm.saving = false;
                this.$apollo.queries.editablePrompts.refetch();
            })
                .catch((e) => {
                vm.saving = false;
                vm.errorNotification(e.message);
            });
        }
    }
    resetPrompts() {
        const vm = this;
        const variables = {
            input: {
                appUuid: vm.appUUID,
            },
        };
        return vm.$apollo
            .mutate({
            mutation: ResetPrompts,
            variables,
        })
            .then(() => {
            this.successNotification(`Successfully Resetted Chatbot Prompts`);
            vm.saving = false;
        })
            .catch((e) => {
            vm.saving = false;
            vm.errorNotification(e.message);
        })
            .finally(() => {
            this.$apollo.queries.editablePrompts.refetch();
        });
    }
    discardPrompts() {
        this.successNotification(`Successfully Discarded Chatbot Prompts`);
        this.$apollo.queries.editablePrompts.refetch();
        this.hideConfirmationDialog();
    }
    clearDummyMessages() {
        const vm = this;
        const variables = {
            input: {
                appUuid: vm.appUUID,
                dummyType: 'prompt_manager',
            },
        };
        return vm.$apollo
            .mutate({
            mutation: CreateNewDummyRecipient,
            variables,
        })
            .then(() => {
            this.successNotification(`Successfully Cleared Messages`);
            this.$store.commit('setSelectedRecipient', {
                baseUuid: '',
                page: null,
                psid: '',
                uuid: '',
            });
            vm.saving = false;
        })
            .catch((e) => {
            vm.saving = false;
            vm.errorNotification(e.message);
        })
            .finally(() => {
            this.$apollo.queries.duumyRecipient.refetch();
        });
    }
    async mounted() {
        await this.$apollo.queries.editablePrompts.refetch();
        await this.$apollo.queries.defaultPrompts.refetch();
    }
};
__decorate([
    Getter('selectedRecipient')
], ComponentName.prototype, "selectedRecipient", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], ComponentName.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ComponentName.prototype, "hideConfirmationDialog", void 0);
ComponentName = __decorate([
    Component({
        components: {
            ActionButton,
            ConfirmationDialog,
            RadioBoxGroup,
            BaseTextField,
            MessengerMessages,
            BaseTextArea,
        },
        apollo: {
            duumyRecipient: {
                query: PromptManagerDummyRecipient,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    if (data.promptManagerDummyRecipient) {
                        this.$store.commit('setSelectedRecipient', data.promptManagerDummyRecipient);
                    }
                    return data.promptManagerDummyRecipient;
                },
                fetchPolicy: 'network-only',
            },
            editablePrompts: {
                query: AppEditablePrompts,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    data.appEditablePrompts.forEach((prompt) => {
                        // Initialize selection state based on whether the product is in previouslySelectedProducts
                        if (prompt) {
                            if (prompt.agentType === 'conversation_agent') {
                                this.form.base = prompt.generalAgentPrompt;
                                this.form.promoCode = prompt.promoCodePrompt;
                                this.form.faq = prompt.faqPrompt;
                                this.form.orderStatus = prompt.orderStatusPrompt;
                            }
                        }
                    });
                    return data.appEditablePrompts;
                },
                fetchPolicy: 'cache-and-network',
            },
            defaultPrompts: {
                query: AppDefaultPrompts,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    if (this.editablePrompts.length === 0) {
                        data.appDefaultPrompts.forEach((prompt) => {
                            if (prompt) {
                                if (prompt.agentType === 'conversation_agent') {
                                    this.form.base = prompt.generalAgentPrompt;
                                    this.form.promoCode = prompt.promoCodePrompt;
                                    this.form.faq = prompt.faqPrompt;
                                    this.form.orderStatus = prompt.orderStatusPrompt;
                                }
                            }
                        });
                    }
                    return data.appDefaultPrompts;
                },
                fetchPolicy: 'cache-and-network',
            },
        },
        validations() {
            const notRequired = () => false;
            const validations = {
                form: {
                    base: {
                        required: requiredIf(notRequired),
                        maxLength: maxLength(800),
                    },
                    promoCode: {
                        required,
                        maxLength: maxLength(800)
                    },
                    faq: {
                        required,
                        maxLength: maxLength(800)
                    },
                    orderStatus: {
                        required,
                        maxLength: maxLength(800)
                    },
                },
            };
            return validations;
        },
    })
], ComponentName);
export default ComponentName;
